var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import React from "react";
import { Alert } from "react-bootstrap";
import { useOrderBookAlertController } from "./hooks/OrderBookAlertController";
var OrderBookAlert = function () {
    var _a = useOrderBookAlertController(), counts = _a.counts, setCounts = _a.setCounts, onClickPendingTransactionView = _a.onClickPendingTransactionView;
    if (!counts.visible)
        return null;
    var total = counts.aifCount + counts.pmsCount;
    return (React.createElement(Alert, { bsPrefix: "aif-pms-alert", variant: "warning", className: "d-flex justify-content-between align-items-center" },
        React.createElement("div", { className: "d-flex gap-3 align-items-center" },
            React.createElement("i", { className: "edel-icon-attention txt-orange-light", style: { fontSize: 22 } }),
            React.createElement("div", { className: "d-flex align-items-center gap-3" },
                React.createElement("p", { className: "content DMSanN_14_400 txt-midnight-blue" },
                    React.createElement("strong", null,
                        "You have ",
                        total,
                        " orders pending for approval"),
                    ". Please review and complete them to proceed."),
                counts.aifCount > 0 && (React.createElement(Alert.Link, { className: "DMSanN_14_400 txt-han-blue font-weight-400 text-decoration-none", onClick: function () {
                        onClickPendingTransactionView(ESubProductIds.AIF);
                    } },
                    React.createElement("span", { className: "text-decoration-underline me-1" },
                        "AIF(",
                        counts.aifCount,
                        ")"))),
                counts.pmsCount > 0 && (React.createElement(Alert.Link, { className: "DMSanN_14_400 txt-han-blue font-weight-400 text-decoration-none", onClick: function () {
                        onClickPendingTransactionView(ESubProductIds.PMS);
                    } },
                    React.createElement("span", { className: "text-decoration-underline me-1" },
                        "PMS(",
                        counts.pmsCount,
                        ")"))))),
        React.createElement("i", { onClick: function () { return setCounts(function (prev) { return (__assign(__assign({}, prev), { visible: false })); }); }, className: "edel-icon-close d-flex justify-content-center align-items-center text-han-blue cursor-pointer" })));
};
export default OrderBookAlert;
